/* eslint-disable max-len */
import glamorous from 'glamorous';
import { mediaQueries } from '../../constants/mediaqueries.const';
import highFiveLockup from '../../images/HighFive_LockUp_NoSwoosh.svg';

const ndeBlack = '#061B38';

// Main wrapper
export const DashboardPageWrapper = glamorous.div('ncss-container fixed-fluid', () => ({
  paddingLeft: '56px',
  paddingRight: '56px',
  paddingTop: '56px',
  paddingBottom: '56px',
  backgroundColor: '#f4f4f4'
}));
DashboardPageWrapper.displayName = 'DashboardPageWrapper';

// First Row to conatin Sent and Received and Graphs
export const DashboardRowOneWrapper = glamorous.div('ncss-row-sm-12', () => ({
  margin: '0',
}));
DashboardRowOneWrapper.displayName = 'DashboardRowOneWrapper';

// Box to contain Sent and Received H5 on the right
export const SentReceivedBoxWrapper = glamorous.div('ncss-col-sm-3 ta-sm-c', () =>({
  verticalAlign: 'top',
  padding: '0px',
}))
SentReceivedBoxWrapper.displayName = 'SentReceivedBoxWrapper';

// Actual box and background
export const BoxContainer = glamorous.div('ncss-row', () =>({
  [mediaQueries.tablet]: {
    height: '270px',
  },
  [mediaQueries.desktop]: {
    height: '290px',
  },
  width: '100%',
  margin: '0',
  padding: '0',
  color: '#ffffff',
  background: '#061b38',
}))
BoxContainer.displayName = 'BoxContainer';

// Number container
export const SentReceivedContainer = glamorous.div('ncss-col-sm-6 ta-sm-c mt6-sm ncss-marketing', () =>({
  [mediaQueries.tablet]: {
    fontSize: '75px',
  },
  fontSize:'40px',
  padding: '0',
  width: '50%',
}))
SentReceivedContainer.displayName = 'SentReceivedContainer';

export const ReceivedContainer = glamorous.div('ncss-col-sm-6 ta-sm-c mt6-sm ncss-marketing', () =>({
  [mediaQueries.tablet]: {
    fontSize: '75px',
  },
  fontSize:'40px',
  padding: '0',
  width: '50%',
  color: '#061b38',
}))
ReceivedContainer.displayName = 'ReceivedContainer';


// Title for sent and received
export const SentReceivedTitleWrapper = glamorous.div('ncss-col-sm-6 ta-sm-c ncss-base', () =>({
  [mediaQueries.tablet]: {
    fontSize: '20px',
  },
  fontSize:'10px',
  width: '50%',
  padding: '0',
}))
SentReceivedTitleWrapper.displayName = 'SentReceivedTitleWrapper';

// Title for sent and received
export const ExportTitleWrapper = glamorous.div('ncss-row-sm-12 ta-sm-c ncss-base u-underline', () =>({
  [mediaQueries.tablet]: {
    fontSize: '20px',
  },
  marginTop: '20px',
  fontSize:'10px',
  width: '100%',
}))
ExportTitleWrapper.displayName = 'ExportTitleWrapper';

// Graph to contain Sent and Received H5 on the right
export const GraphWrapper = glamorous.div('ncss-col-sm-9', () =>({
  padding: '0 56px 0 0',
  verticalAlign: 'top',
}))
GraphWrapper.displayName = 'GraphWrapper';

// Graph to contain Sent and Received H5 on the right
export const GraphInlineWrapper = glamorous.div('ncss-col-sm-12', () =>({
  padding: '0',
  backgroundColor: 'transparent',
  width: '100%', 
}))
GraphInlineWrapper.displayName = 'GraphInlineWrapper';

export const TableWrapper = glamorous.div('ncss-col', () =>({
  width: '100%', 
}))
TableWrapper.displayName = 'TableWrapper';

export const OverviewWrapper = glamorous.div('ncss-base', () => ({
  marginBottom: '93px',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  flexDirection: 'row',
  color: '#333',
  height: '80px',
  lineHeight: '48px',
  fontSize: '12px',
  '> a': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}))
OverviewWrapper.displayName = 'OverviewWrapper';

export const TabContainer = glamorous.div('ncss-base prl4-sm prl6-md pb10-sm', () => ({
  [mediaQueries.tablet]: {
    fontSize: '12px',
  },
  [mediaQueries.desktop]: {
    fontSize: '14px',
  },
  position: 'relative',
  fontSize: '10px',
  width: '30%',
  height: '48px',
  lineHeight: '48px',
  top: 0,
  display: 'flex',
  justifyContent: 'space-around',
  '> button': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}));
TabContainer.displayName = 'TabContainer';

export const HistoryWrapper = glamorous.div('ncss-col-sm-9', () =>({
  [mediaQueries.tablet]: {
    fontSize: '30px',
  },
  padding: '0 0 0 4px',
  verticalAlign: 'top',
  justifyContent: 'space-around',
  fontSize:'20px',
  fontFamily: 'HelveticaNeue-Medium',
  fontWeight: '500px'
}))
HistoryWrapper.displayName = 'HistoryWrapper';

export const TotalWrapper = glamorous.div('ncss-col-sm-9', () =>({
  [mediaQueries.tablet]: {
    fontSize: '30px',
  },
  display: 'flex',
  gap: '16px',
  backgroundColor: '#061b38',
  color: '#ffffff',
  width: '100%',
  padding: '12px 12px 0px 12px',
}))
HistoryWrapper.displayName = 'TotalWrapper';

export const SelectContainer = glamorous.select('', () =>({
  backgroundColor: '#061b38',
  color: '#ffffff',
  width: '100%',
  padding: '12px 12px 12px 12px',
  borderRadius: '24px',
  border: '2px solid white',
  zIndex: '2',
  fontSize: '16px',
}))
HistoryWrapper.displayName = 'TotalWrapper';

export const DashboardUserBanner = glamorous.div('ncss-col-sm-12', () =>({
  padding: '0',
  justifyContent: 'space-between',
  backgroundColor: '#ffffff',  
  height: '80px',
  display: 'flex',
  flexDirection: 'row',
}))
DashboardUserBanner.displayName = 'DashboardUserBanner';

export const SentRecTabContainer = glamorous.div('ncss-col-sm-3 ncss-base ', () => ({
  [mediaQueries.tablet]: {
    fontSize: '16px',
  },
  [mediaQueries.desktop]: {
    fontSize: '14px',
  },
  verticalAlign: 'top',
  fontSize: '12px',
  height: '56px',
  display: 'flex',
  '> button': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}));
SentRecTabContainer.displayName = 'SentRecTabContainer';

export const UserTabContainer = glamorous.div('ncss-base', () => ({
  [mediaQueries.tablet]: {
    fontSize: '12px',
  },
  [mediaQueries.desktop]: {
    fontSize: '14px',
  },
  height: '80px',
  lineHeight: '80px',
  position: 'relative',
  fontSize: '10px',
  width: '45%',
  top: 0,
  display: 'flex',
  justifyContent: 'space-around',
  '> button': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}));
UserTabContainer.displayName = 'UserTabContainer';

export const HighFiveLockup = glamorous.div(() => ({
  display: 'inline-block',
  width: '300px',
  height: '80px',
  background: `url(${highFiveLockup}) no-repeat center center`,
  backgroundSize: 'contain !important',
  marginLeft: '10px'
}));
HighFiveLockup.displayName = 'HighFiveLockup';





// WEBPACK FOOTER //
// ./src/containers/DashboardPage/DashboardPersonal.style.js